import { Component } from '@angular/core';
import {SidenavComponent} from "../sidenav/sidenav.component";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {MatListItem, MatNavList} from "@angular/material/list";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    SidenavComponent,
    LocalizeRouterPipe,
    MatListItem,
    MatNavList,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css'
})
export class AdminLayoutComponent {

}
